import '../../components/question_charts';
import '../../components/question_right';
import '../../components/question_wrong';
import '../../components/resource_limit_counter';
import './blockestatistica_desktop.png';
import './blockestatistica_responsive.png';
import './exclamacao_img.png';
import './index.scss';
import 'components/freemium/block_message';

class QuestionStatisticsTab {
  constructor($context) {
    this.$context = $context;
    this.insightsGenerated = false;

    const enabled = this.$context
      .find('.q-question-statistics')
      .data('ai-coach-enabled');

    const params = this.params();
    const isInvalid = params.some(
      param => param === null || param === undefined
    );

    UserTracker.emit('event', {
      eventName: 'stats question clicked',
      data: {
        'coach help available': !isInvalid,
        'coach help enabled': enabled
      }
    });

    if (String(enabled) === 'false') return;

    if (!isInvalid) {
      this.bind();
    }
  }

  params() {
    const percentages = this.$context
      .find('#js-most-answered-alternatives-chart')
      .data('pecentages');
    const options = this.$context
      .find('#js-most-answered-alternatives-chart')
      .data('options');
    const subjectIds = this.$context
      .find('.q-suggestion-box')
      .data('subject-ids');

    const category = this.$context
      .parents('.q-question-item')
      .find('.q-question-breadcrumb')
      .text()
      .replace(/\s+/g, ' ')
      .replace('( assuntos)', '')
      .trim();

    const answer = this.$context
      .parents('.q-question-item')
      .find('.q-question')
      .data('answer');

    const correctAnswer = this.$context
      .parents('.q-question-item')
      .find('.q-question')
      .data('correct-answer');

    const disciplineId = this.$context
      .parents('.q-question-item')
      .find('.q-question')
      .data('discipline-id');

    return [
      category,
      answer,
      correctAnswer,
      percentages,
      options,
      disciplineId,
      String(subjectIds),
      Number(currentUser.id)
    ];
  }

  bind() {
    const $suggestionBox = $('.q-suggestion-box', this.$context);
    const $coachTrigger = $suggestionBox.find('.q-coach-trigger');

    $suggestionBox.css('display', 'flex');
    setTimeout(() => {
      $suggestionBox.css('box-shadow', 'none').css('animation', 'none');
    }, 2500);

    $coachTrigger.off('click').on('click', () => {
      this.handleSuggestionBox();
    });
  }

  bindFeedback() {
    const $feedbackButton = $('[data-feedback]', this.$context);

    $feedbackButton.off('click').on('click', event => {
      const feedback = $(event.currentTarget).data('feedback');

      UserTracker.emit('event', {
        eventName: 'evaluated coach help',
        data: {
          feature: 'stats question belt',
          feedback
        }
      });

      $feedbackButton.hide();
    });
  }

  async handleSuggestionBox() {
    if (this.insightsGenerated) return;
    this.insightsGenerated = true;

    UserTracker.emit('event', {
      eventName: 'coach help wanted',
      data: {
        feature: 'stats question belt'
      }
    });

    const loadingElement = this.$context.find('.q-suggestion-loading');
    const triggerElement = this.$context.find('.q-coach-trigger');
    const feedbackElement = this.$context.find('.q-coach-feedback');
    const coachResponse = this.$context.find('.q-coach-response');
    const $suggestionBox = $('.q-suggestion-box', this.$context);

    $suggestionBox.addClass('open');
    triggerElement.hide();
    loadingElement.css('display', 'flex').css('height', 'auto');

    try {
      const body = await this.fetchStatistics();
      const html = this.generateStatisticsHtml(body);
      coachResponse.html(html).show();
      feedbackElement.css('display', 'flex').css('height', 'auto');
      loadingElement.hide();
      this.bindFeedback();
    } catch (error) {
      console.error('Failed to fetch statistics:', error);
    }
  }

  async fetchStatistics() {
    const response = await fetch(
      'https://niamh.grupoq.io/api/concursos/statistics',
      {
        method: 'POST',
        body: JSON.stringify({ params: this.params() }),
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }

  generateStatisticsHtml(data) {
    const insightsHtml = data.message.insights
      .map(insight => `<p>${insight.insight}</p>`)
      .join('');
    return `<p><strong>Análise do Treinador para você</strong></p>${insightsHtml}`;
  }
}

(function ($) {
  'use strict';

  $(document).on('componentLoaded:questions/question_statistics', (e, data) => {
    new QuestionStatisticsTab(data.context);

    const redirect_mesa = () => {
      const buttonElement = document.getElementById('link_go_to_ils');
      const url = buttonElement?.getAttribute('name');
      const question_id = buttonElement?.getAttribute('question_id');

      const timestamp = new Date().getTime();
      let search = location.search.slice(1, location.search.length);

      if (!search) {
        search += 'my_questions=all';
      }

      const ils_complete_url = `${url}playground/questoes?statistic_question_id=${question_id}&${search}&timestamp=${timestamp}`;

      if (buttonElement) {
        buttonElement.href = ils_complete_url;
      }
    };

    redirect_mesa();
  });
})(jQuery);
